import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
// import ProtectedRoute from './components/ProtectedRoute'; // Not needed for public access
import AuthHeader from './components/AuthHeader';
import Login from './components/Login';
import Register from './components/Register';
import ECMRList from './components/ECMRList';
import ImportECMR from './components/ImportECMR';
import ViewECMR from './components/ViewECMR';
import CreateECMR from './components/CreateECMR';
import EditECMR from './components/EditECMR';
import ExportECMR from './components/ExportECMR';
import ValidateECMR from './components/ValidateECMR';
import SignECMR from './components/SignECMR';
import LegalNotice from './components/LegalNotice';
import './App.css';

// Create Material-UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#2563eb', // blue-600
    },
    secondary: {
      main: '#dc2626', // red-600
    },
  },
});

function App() {
  const [isLegalNoticeOpen, setIsLegalNoticeOpen] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-100">
            <AuthHeader />
            
            <main className="py-4">
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                
                {/* Public routes - no authentication required */}
                <Route path="/" element={<ECMRList />} />
                <Route path="/import" element={<ImportECMR />} />
                <Route path="/view/:id" element={<ViewECMR />} />
                <Route path="/create" element={<CreateECMR />} />
                <Route path="/edit/:id" element={<EditECMR />} />
                <Route path="/export/:id" element={<ExportECMR />} />
                <Route path="/validate/:id" element={<ValidateECMR />} />
                <Route path="/sign/:id" element={<SignECMR />} />
              </Routes>
            </main>
            
            <footer className="bg-gray-800 text-white p-4">
              <div className="container mx-auto text-center">
                <p className="mb-2">© {new Date().getFullYear()} Open e-CMR - Aplicación para la gestión de documentos e-CMR</p>
                <button
                  onClick={() => setIsLegalNoticeOpen(true)}
                  className="text-sm text-gray-400 hover:text-white underline"
                >
                  Aviso Legal
                </button>
              </div>
            </footer>

            <LegalNotice 
              isOpen={isLegalNoticeOpen}
              onClose={() => setIsLegalNoticeOpen(false)}
            />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
